import { createApp } from 'vue';
import App from './App.vue';
import vClickOutside from 'click-outside-vue3';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

import { FocusTrap } from 'focus-trap-vue';
import { bootstrap } from '@/lib/modules';
import { install } from '@/lib/plugins';
import modules from '@/modules';
import plugins from '@/plugins';
import setupVueTippy from '@/lib/VueTippy'
import vMaskV3 from './directives/vMask.js';
import '@/lib/VueTippy/styles.scss'
import 'dayjs/locale/ru'
import { registerGlobalComponents } from '@/components/ui/global'
import { plugin as SkifUI } from '@skifapp/skif-ui'
import '@skifapp/skif-ui/style.css'
import './assets/sass/main.scss';
import './assets/sass/styles/index.scss';

const app = createApp(App)
  .use(ElementPlus)
  .use(vClickOutside)
  .component('FocusTrap', FocusTrap)
  .directive('mask', vMaskV3);

setupVueTippy(app)
app.use(SkifUI)
install(
  bootstrap(
    app,
    modules
  ),
  plugins
).mount('#app');

registerGlobalComponents(app)
